<template>
  <div :class="['common_aside', classScreenType]" @click="settingVisible = false">
    <h3 class="title">
      <span>资源库</span>
      <span v-show="isMini" class="icon" @click.stop="settingVisible = !settingVisible" />
      <ToolsSettingList
        v-show="settingVisible" class="setting_list" :width="widthToolsSettingList"
        @selectIndex="settingListSelectIndex" />
    </h3>
    <ul class="list_box">
      <li
        v-for="(item, index) in asideArr" v-show="isShowAsideItem(item)" :key="item[cat2] || item[cat1] || item.key" v-report:mainclick="{ area: 'leftbar', pos: index }"
        class="list_item" :class="`${(!item[isMore] && activeIndex === index) ? 'active' : ''} ${item.icon || ''}`" @click="clickItem(item, index)"><span class="font">{{ item.name }}</span></li>
    </ul>
  </div>
</template>

<script>
import ToolsSettingList from '@/components/Tools/ToolsSettingList.vue'

import { ClientOpenTemplateByUrl, ClientOpenBrowser, ClientGetVersion } from '@/api/clientApi.js'
import { cat1, cat2, winTypeMap, channelType } from '@/common/const.js'
import {
  isCustomer, isMore, isMidAutumnPack,
  typeOpenBrowser
} from '@/common/data.js'
import { CacheSessionGetChannel } from '@/common/cache.js'
import { openActivity } from '@/common/business.js'
import { report } from '@/report/index.js'

export default {
  name: 'Aside',

  components: { ToolsSettingList },

  data () {
    return {
      cat1, cat2, isMore,
      active: 0,
      settingVisible: false,
      showCustomer: false
    }
  },

  inject: {
    isErrorPage: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    classScreenType () {
      return this.$store.getters.classNameScreenType
    },

    isLowScreen () {
      return this.$store.getters.isLowScreen
    },

    isLoginedIn () {
      return this.$store.getters.isLoginedIn
    },

    asideArr () {
      return this.$store.state.home.asideArr
    },

    activeIndex () {
      return this.$store.state.activeIndex
    },

    isMini () {
      return this.$store.getters.isMini
    },

    isTestMidAutumn () {
      return this.$store.getters['abTest/isTestMidAutumn']
    },

    isVipForever () {
      return this.$store.getters.isVipForever
    },

    widthToolsSettingList () {
      return this.isLowScreen ? 50 : 69
    }
  },

  created () {
    this.setShowCustomer()
  },

  methods: {
    clickItem (item, index) {
      if (item.type === typeOpenBrowser) {
        const url = item.url
        ClientOpenBrowser(url)
        return
      }

      if (item[isMore]) { // isMore关键词来自data.js
        const url = item.getUrl() // 执行内部函数
        this.clickMoreHandle(url)
        return
      }

      if (item[isMidAutumnPack]) { // isMore关键词来自data.js
        /** 上报-点击活动红包 **/
        report('mainclick', { area: 'activity', pos: 0 })
        openActivity(this.$store)
        return
      }

      this.clickChangeActiveIndex(index)
    },

    clickChangeActiveIndex (index) {
      setTimeout(() => { // 指令上报慢于click事件，但是上报有ext关于收起展开的参数，所以，添加定时器处理先后执行问题
        this.isErrorPage && this.$router.push('/') // 错误页面重置
        this.$emit('changeActiveIndex', index)
      }, 0)
    },

    clickMoreHandle (url) {
      const channel = CacheSessionGetChannel()

      if (channel === channelType.dg || channel === channelType.duba) {
        ClientOpenTemplateByUrl(url) // 打开素材站客户端
        return
      }

      ClientOpenBrowser(url) // 打开浏览器
    },

    isShowAsideItem (item) {
      // 没有登录不显示客服入口
      if (item[isCustomer] && !this.isLoginedIn) {
        return false
      }

      // 如果打开外链有bug，不展示客服入口
      if (item[isCustomer] && !this.showCustomer) {
        return false
      }

      // 不是测试中秋活动的实验组，不显示红包入口，终身会员也不显示入口
      if (item[isMidAutumnPack] && (!this.isTestMidAutumn || this.isVipForever)) {
        return false
      }

      return true
    },

    settingListSelectIndex (index) {
      setTimeout(() => { // 同上
        if (index === 1) {
          this.$store.dispatch('vuexChangeWinType', winTypeMap.normal)
          this.$store.commit('tipsDialog/vuexChangeSettingDialogVisible', true)
        }
      })
    },

    setShowCustomer () {
      // 支持ClientGetVersion接口以前的版本打开外链有大小字符的bug，支持ClientGetVersion接口的客户端版本才能打开客服入口
      ClientGetVersion(() => {
        this.showCustomer = true
      }, () => {
        this.showCustomer = false
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.common_aside { width: 69px; height: 100%; background-color: #fff; border-right: 1px solid $border_color;
  .title { padding: 15px 0; margin-bottom: 10px; font-size: 16px; font-weight: 400; color: $font_color_8; text-align: center; border-bottom: 1px solid $border_color;
    .icon { display: inline-block; width: 14px; height: 14px; background: url(~@/assets/images/icon_setting_down.svg) center center no-repeat;
      &:hover { background-image: url(~@/assets/images/icon_setting_down_hover.svg); }
    }
    .setting_list { top: 43px; left: 0; }
  }
  .list_item { position: relative; height: 76px; text-align: center; cursor: pointer; background-repeat: no-repeat; background-position: center 15px; background-size: 28px 28px;
    &:hover { background-color: #eef0f7;
      &.icon_aside_ppt1 { background-image: url(~@/assets/images/icon_aside_ppt1_hover.svg); }
      &.icon_aside_ppt2 { background-image: url(~@/assets/images/icon_aside_ppt2_hover.svg); }
      &.icon_aside_ppt3 { background-image: url(~@/assets/images/icon_aside_ppt3_hover.svg); }
      &.icon_aside_ppt4 { background-image: url(~@/assets/images/icon_aside_ppt4_hover.svg); }
      &.icon_aside_ppt5 { background-image: url(~@/assets/images/icon_aside_ppt5_hover.svg); }
      &.icon_aside_ppt6 { background-image: url(~@/assets/images/icon_aside_ppt6_hover.svg); }
      &.icon_aside_excel1 { background-image: url(~@/assets/images/icon_aside_excel1_hover.svg); }
      &.icon_aside_excel2 { background-image: url(~@/assets/images/icon_aside_excel2_hover.svg); }
      &.icon_aside_excel3 { background-image: url(~@/assets/images/icon_aside_excel3_hover.svg); }
      &.icon_aside_excel4 { background-image: url(~@/assets/images/icon_aside_excel4_hover.svg); }
      &.icon_aside_excel5 { background-image: url(~@/assets/images/icon_aside_excel5_hover.svg); }
      &.icon_aside_excel6 { background-image: url(~@/assets/images/icon_aside_excel6_hover.svg); }
      &.icon_aside_word1 { background-image: url(~@/assets/images/icon_aside_word1_hover.svg); }
      &.icon_aside_word2 { background-image: url(~@/assets/images/icon_aside_word2_hover.svg); }
      &.icon_aside_word3 { background-image: url(~@/assets/images/icon_aside_word3_hover.svg); }
      &.icon_aside_word4 { background-image: url(~@/assets/images/icon_aside_word4_hover.svg); }
      &.icon_aside_word5 { background-image: url(~@/assets/images/icon_aside_word5_hover.svg); }
      &.icon_customer { background-image: url(~@/assets/images/icon_customer_hover.svg); }
      &.icon_aside_more { background-image: url(~@/assets/images/icon_aside_more_hover.svg); }
    }
    &.active { background-color: #fff !important;
      &.icon_aside_ppt1 { background-image: url(~@/assets/images/icon_aside_ppt1_active.svg); }
      &.icon_aside_ppt2 { background-image: url(~@/assets/images/icon_aside_ppt2_active.svg); }
      &.icon_aside_ppt3 { background-image: url(~@/assets/images/icon_aside_ppt3_active.svg); }
      &.icon_aside_ppt4 { background-image: url(~@/assets/images/icon_aside_ppt4_active.svg); }
      &.icon_aside_ppt5 { background-image: url(~@/assets/images/icon_aside_ppt5_active.svg); }
      &.icon_aside_ppt6 { background-image: url(~@/assets/images/icon_aside_ppt6_active.svg); }
      &.icon_aside_excel1 { background-image: url(~@/assets/images/icon_aside_excel1_active.svg); }
      &.icon_aside_excel2 { background-image: url(~@/assets/images/icon_aside_excel2_active.svg); }
      &.icon_aside_excel3 { background-image: url(~@/assets/images/icon_aside_excel3_active.svg); }
      &.icon_aside_excel4 { background-image: url(~@/assets/images/icon_aside_excel4_active.svg); }
      &.icon_aside_excel5 { background-image: url(~@/assets/images/icon_aside_excel5_active.svg); }
      &.icon_aside_excel6 { background-image: url(~@/assets/images/icon_aside_excel6_active.svg); }
      &.icon_aside_word1 { background-image: url(~@/assets/images/icon_aside_word1_active.svg); }
      &.icon_aside_word2 { background-image: url(~@/assets/images/icon_aside_word2_active.svg); }
      &.icon_aside_word3 { background-image: url(~@/assets/images/icon_aside_word3_active.svg); }
      &.icon_aside_word4 { background-image: url(~@/assets/images/icon_aside_word4_active.svg); }
      &.icon_aside_word5 { background-image: url(~@/assets/images/icon_aside_word5_active.svg); }
      &.icon_customer { background-image: url(~@/assets/images/icon_customer_active.svg); }
      &.icon_aside_more { background-image: url(~@/assets/images/icon_aside_more_active.svg); }
      .font { color: $font_color; }
    }
    &.icon_aside_ppt1 { background-image: url(~@/assets/images/icon_aside_ppt1.svg); }
    &.icon_aside_ppt2 { background-image: url(~@/assets/images/icon_aside_ppt2.svg); }
    &.icon_aside_ppt3 { background-image: url(~@/assets/images/icon_aside_ppt3.svg); }
    &.icon_aside_ppt4 { background-image: url(~@/assets/images/icon_aside_ppt4.svg); }
    &.icon_aside_ppt5 { background-image: url(~@/assets/images/icon_aside_ppt5.svg); }
    &.icon_aside_ppt6 { background-image: url(~@/assets/images/icon_aside_ppt6.svg); }
    &.icon_aside_excel1 { background-image: url(~@/assets/images/icon_aside_excel1.svg); }
    &.icon_aside_excel2 { background-image: url(~@/assets/images/icon_aside_excel2.svg); }
    &.icon_aside_excel3 { background-image: url(~@/assets/images/icon_aside_excel3.svg); }
    &.icon_aside_excel4 { background-image: url(~@/assets/images/icon_aside_excel4.svg); }
    &.icon_aside_excel5 { background-image: url(~@/assets/images/icon_aside_excel5.svg); }
    &.icon_aside_excel6 { background-image: url(~@/assets/images/icon_aside_excel6.svg); }
    &.icon_customer { background-image: url(~@/assets/images/icon_customer.svg); }
    &.icon_aside_more { background-image: url(~@/assets/images/icon_aside_more.svg); }
    &.icon_aside_word1 { background-image: url(~@/assets/images/icon_aside_word1.svg); }
    &.icon_aside_word2 { background-image: url(~@/assets/images/icon_aside_word2.svg); }
    &.icon_aside_word3 { background-image: url(~@/assets/images/icon_aside_word3.svg); }
    &.icon_aside_word4 { background-image: url(~@/assets/images/icon_aside_word4.svg); }
    &.icon_aside_word5 { background-image: url(~@/assets/images/icon_aside_word5.svg); }
    &.icon_customer { background-image: url(~@/assets/images/icon_customer.svg); }
    &.icon_aside_more { background-image: url(~@/assets/images/icon_aside_more.svg); }
    &.icon_aside_mid_autumn_pack { background-image: url(~@/assets/images/icon_mid_autumn_pack.gif); background-position: center; background-size: cover; }
    .font { position: absolute; top: 50px; left: 0; width: 100%; font-size: 12px; color: #9497ac; }
  }
}
.common_aside.screen_type_low { width: 50px;
  .title { margin-bottom: 5px; font-size: 14px; }
  .list_item { height: 55px; background-position: center 5px;
    .font { top: 36px; }
  }
}
</style>
